
<div>
  <page-header />
  <div class="d-flex align-items-center justify-content-center mt-4">
    <div class="no-access-error">
        Access Denied
      </div>
    </div>
  </div>  
